<template>
    <b-form>
        <b-form-group
            label="Patient:"
            class
            v-if="data.module != 'patient'"
            label-cols="3"
            label-for="patients"
        >
            <vet-select
                id="patients"
                v-model="data.patients"
                v-validate="'required'"
                :client-id="data.clientId"
                module="client-patient"
                placeholder="Patient name (required)"
                label="name"
                name="patients"
                :multiple="true"
                :showMenu="false"
                :class="{ 'border-danger': errors.has('patients') }"
            />
        </b-form-group>
        <b-form-group :label-for="`bundles`" :label-cols="3" label="Bundle:">
            <v-select
                max-height="200px"
                id="bundle_id"
                name="bundle_id"
                ref="vselect"
                :options="bundleOptionsExclude"
                v-model="data.bundleId"
                v-validate="'required'"
                placeholder="Select bundle (required)"
                multiple
                label="name"
                :class="{ 'border-danger': errors.has('bundle_id') }"
            />
        </b-form-group>
    </b-form>
</template>

<script>
import vSelect from "vue-select";
import vetSelect from "@/module/commons/vet-select.vue";
import Templates from "@/services/templates";
import { difference } from "lodash";

export default {
    components: { vSelect, vetSelect },
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            bundleOptions: []
        };
    },
    computed: {
        bundleOptionsExclude() {
            return difference(this.bundleOptions, this.data.bundleId);
        }
    },
    watch: {},
    mounted() {
        let self = this;
        this.$nextTick(() => {
            self.$emit("loading");
            Promise.all([self.getBundle()]).then(() => {
                self.$emit("loaded");
            });
        });
    },
    methods: {
        getBundle() {
            let self = this;
            Templates.getBundles().then(response => {
                self.bundleOptions = response.resources;
            });
        }
    }
};
</script>
